import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from 'app/modules/common/entities/rest.response.model';
import API from '../../common/services/api.config.json';
import { ApiService } from 'app/modules/common/services/api.service';

@Injectable({providedIn:'root'})
export class EmpresaService {

  constructor(private apiService: ApiService) { }

  GetAttributesByIndex(empresaId: number, index: number): Observable<RestResponse> {
    let url = `${API.Empresa.getAttributesByIndex}`;
    url = url.replace('{index}', index.toString()).replace('{id}', empresaId.toString());
    return this.apiService.get(url);
  }

  GetCompanyAdminstrator(empresaId: string): Observable<RestResponse> {
    let url = `${API.Empresa.getCompanyAdministrator}`;
    url = url.replace('{id}', empresaId);
    return this.apiService.get(url);
  }
}
